// export const api = "http://localhost:4000/api/v1";
export const api = "https://wristlink-71b54efd89ef.herokuapp.com/api/v1";
